import { ReactElement } from 'react';

const SignLoad = (): ReactElement => {
    return <div>Sign</div>;
};

export default SignLoad;
